import React, { useEffect, useState } from 'react';
import { MdAdd, MdClose, MdDelete, MdEdit, MdMail, MdPhone, MdSend, MdTimer, MdVisibility } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import CountUp from 'react-countup';
import { ExclamationCircleFilled } from '@ant-design/icons';
import api from '../../../services/api';
import { Container, Cards, Card, Title, ViewInput, Table, Scroll } from '../../../GlobalStyles';
import loadingPhoto from "./../../../images/loading.gif"
import { toast } from 'react-toastify';
import { Button, Modal, Input, Pagination, DatePicker, Select } from 'antd';
import { FaFileContract, FaUsers, FaWhatsapp } from "react-icons/fa";
import { ModalConfirm, InputTel } from './styles';
import { addDays, format } from 'date-fns';
import { ContainerLead, Label } from './styles';
import dayjs from 'dayjs';
import weekday from "dayjs/plugin/weekday"
import localeData from "dayjs/plugin/localeData"

const { TextArea } = Input;
const { RangePicker } = DatePicker;

dayjs.extend(weekday)
dayjs.extend(localeData)

const LeadsFechados = () => {

  const navigate = useNavigate()

  const [leads, setLeads] = useState([]);
  const [lead, setLead] = useState({});
  const [leadsTotal, setLeadsTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(0)
  const [id, setId] = useState("")
  const [dateStart, setDateStart] = useState(addDays(new Date(), -30))
  const [dateEnd, setDateEnd] = useState(new Date())
  const [isOpen, setIsOpen] = useState(false)
  const [isOpenLead, setIsOpenLead] = useState(false)
  const [user, setUser] = useState("")
  const [users, setUsers] = useState([])
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [phone_number, setPhone_number] = useState("")
  const [observation, setObservation] = useState("")
  const [employees, setEmployees] = useState("")
  const [necessity, setNecessity] = useState("")
  const [cnpj, setCnpj] = useState("")
  const [all, setAll] = useState(true)
  const [location, setLocation] = useState("")

  useEffect(() => {
    loadLeads(page, all, dateStart, dateEnd, user)
  }, [page, all, dateStart, dateEnd, user]);

  useEffect(() => {
    loadFranqueados()
  }, []);

  async function loadFranqueados() {
    await api.get(`/users`).then((response) => {
      setUsers(response.data.filter((item)=>{return item.category === "franqueado"}))
    }).catch(({ response }) => {
        if (response) {
            if (response.data) {
                if (response.data.message) {
                    toast.warn(response.data.message)
                } else {
                    toast.error("Erro Interno. verifique sua conexão e tente novamente")
                }
            } else {
                toast.error("Erro Interno. verifique sua conexão e tente novamente")
            }
        } else {
            toast.error("Erro Interno. verifique sua conexão e tente novamente")
        }
    })
  }


  async function loadLeads(page, all, dateStart, dateEnd, user) {
    await api.get(`/leads-close?page=${page}${!all ? `&dateStart=${dateStart}&dateEnd=${dateEnd}` : ""}${user ? `&userId=${user}` : ""}`).then((response) => {
      let leads = response.data.leads
      leads.map((item)=>{
        item.contracts.map((data) => {
          item.valueContract = 0
          data.services.map((service) => {
                item.valueContract += service.amount * service.value
          })
          if (data.service_value) {
              item.valueContract += data.service_value
          }
          if (data.discount) {
            item.valueContract -= data.discount
          }
        })
        item.completedValue = item.contracts.reduce((total, contract) => {
          return contract.status === 'assinado' ? total + item.valueContract : total;
        }, 0);
        item.lostValue = item.contracts.reduce((total, contract) => {
          return (contract.status === 'expirado' || contract.status === 'recusado') ? total + item.valueContract : total;
        }, 0);
      })
      setLeads(leads)
      setLeadsTotal(response.data.leadsTotal)
     }).catch(({ response }) => {
       if (response) {
         if (response.data) {
           if (response.data.message) {
             toast.warn(response.data.message)
           } else {
             toast.error("Erro Interno. verifique sua conexão e tente novamente")
           }
         } else {
           toast.error("Erro Interno. verifique sua conexão e tente novamente")
         }
       } else {
         toast.error("Erro Interno. verifique sua conexão e tente novamente")
       }
     })
    setIsLoading(false);
  }

  function getDate(date) {
    let fortmatDate = date.split("/")
    return new Date(fortmatDate[2], fortmatDate[1] - 1, fortmatDate[0])
  }

  return (
    <Container>
      <Title>
        <h2>Leads Fechados</h2>
      </Title>
      <Cards>
        <Card>
          <div className="icon">
            <FaUsers color="#848484" size={32} />
          </div>
          <div className="number">
            <CountUp duration={1} end={leadsTotal} separator='.'/>
            <p>Total</p>
          </div>
        </Card>
      </Cards>
      <div style={{display: "flex", flexDirection: "row"}}>

      <ViewInput style={{width: "100%", maxWidth: 300, marginRight: 15}}>
                  <p>Filtrar por Franqueado</p>
                  <Select
                    placeholder="selecionar franqueado"
                    value={user} 
                    showSearch
                    optionFilterProp="children"
                    style={{width: "100%", textAlign: "left"}}
                    onChange={(value) => { 
                      setUser(value)
                      setPage(0)
                    }}>
                      <Select.Option value={""}>Todos Franqueados</Select.Option>
                      {
                        users.map((item)=>{
                          return(
                            <Select.Option value={item.id}>{item.name}</Select.Option>
                          )
                        })
                      }
                  </Select>
                </ViewInput>
                <ViewInput style={{width: "100%", maxWidth: 200, marginRight: 15}}>
                  <p>Visualizar</p>
                    <Button 
                      style={{color: "#FFF", backgroundColor: all ? "#f2760a" : "#FFF", color: !all ? "#f2760a" : "#FFF", width: 80, alignSelf: "flex-end", marginBottom: 5, marginRight: 15, borderColor: "#f2760a"}}
                      onClick={()=>{
                        setAll(true)
                      }}
                    >
                      Todos
                    </Button>
                    <Button 
                      style={{color: "#FFF", backgroundColor: !all ? "#f2760a" : "#FFF", color: all ? "#f2760a" : "#FFF", width: 105, alignSelf: "flex-end", marginBottom: 5, borderColor: "#f2760a"}}
                      onClick={()=>{
                        setAll(false)
                      }}
                    >
                      Por Periodo
                    </Button>
                </ViewInput>
                {
                  !all && (
                    <ViewInput style={{width: "100%", marginRight: 15, maxWidth: 280}}>
                      <p>Alterar Periodo de Cadastro</p>
                      <RangePicker
                        style={{width: "100%"}}
                        placeholder={["data inicial", "data final"]}
                        value={[dateStart ? dayjs(dateStart) : "", dateEnd ? dayjs(dateEnd) : ""]}
                        format={"DD/MM/YYYY"}
                        onChange={(value, dateString)=>{
                          setDateStart(getDate(dateString[0]))
                          setDateEnd(getDate(dateString[1]))
                          setPage(0)
                        }}
                        allowClear={false}
                      />
                    </ViewInput>
                  )
                }
      </div>
      {!isLoading && (
        <>
          {leads?.length ? (
            <>
              <Scroll>
                <Table>
                  <thead>
                    <tr>
                      <td>Nome</td>
                      <td>Valores Fechados</td>
                      <td>Valores Perdidos</td>
                      <td>Franqueado</td>
                      <td>Propostas</td>
                      <td>Cadastro</td>
                      <td style={{ width: 80 }}>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      leads.map(lead => (
                        <tr key={lead.id}>
                          <td>{lead.name}</td>
                          <td>{(lead.completedValue || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                          <td>{(lead.lostValue || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                          <td>{lead.user.name}</td>
                          <td>{lead.contracts.length} propostas</td>
                          <td>{format(new Date(lead.create_at), "dd/MM/yyyy HH:mm")}</td>
                          <td style={{width: 160}}>
                            <div style={{ display: "flex", cursor: "pointer", alignItems: "center", justifyContent: "flex-end", }}>
                              <FaFileContract
                                onClick={() => { 
                                  navigate(`/contracts?lead=${lead.id}&name=${lead.name}`)
                                }}
                                style={{ cursor: "pointer"}}
                                size={18}
                                color={"#001B22"}
                              />
                              <MdTimer
                                onClick={() => { 
                                  navigate(`/clientes/reminders?lead=${lead.id}`)
                                }}
                                style={{ cursor: "pointer", marginLeft: 6}}
                                size={18}
                                color={"#001B22"}
                              />
                              <MdVisibility
                                onClick={() => { 
                                  setLead(lead)
                                  setIsOpenLead(true)
                                }}
                                style={{ cursor: "pointer", marginLeft: 8}}
                                size={18}
                                color={"#001B22"}
                              />
                              <MdEdit
                                onClick={() => {
                                  setId(lead.id)
                                  setName(lead.name)
                                  setEmail(lead.email)
                                  setPhone_number(lead.phone_number)
                                  setNecessity(lead.necessity)
                                  setLocation(lead.location)
                                  setEmployees(lead.employees)
                                  setCnpj(lead.cnpj)
                                  setObservation(lead.observation)
                                  setIsOpen(true)
                                }}
                                style={{ cursor: "pointer", marginLeft: 8 }}
                                size={18}
                                color={"#001B22"}
                              />
                            </div>
                          </td>
                        </tr>
                      ))
                    }
                  </tbody>
                </Table>
              </Scroll>
              <center style={{marginTop: 15}}>
                <Pagination simple defaultCurrent={page + 1} onChange={(page) => {
                    setPage(page - 1)
                  }} 
                  total={leadsTotal} pageSize={30} 
                  showTotal={(total) => `${total} leads`}
                />
              </center>
            </>
          ) : (
            <div className="error">
              <p>Nenhum lead encontrado</p>
            </div>
          )}
        </>
      )}

      {isLoading && <img src={loadingPhoto} style={{ background: "transparent", height: 50, width: 50 }} />}

      <ModalConfirm open={isOpen}>
        <div className="content">
          <div className="content-header">
            <p>{id ? "Editando lead" : "Criando um novo lead"}</p>
            <button type="button" className="close-button">
              <MdClose
                size={20}
                color="#3a3a3a"
                onClick={() => setIsOpen(false)}
              />
            </button>
          </div>
          <ViewInput>
            <p>Nome*</p>
            <Input
              placeholder="nome"
              value={name}
              onChange={(event) => setName(event.target.value)} />
          </ViewInput>
          <ViewInput>
            <p>Email*</p>
            <Input
              placeholder="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)} />
          </ViewInput>
          <ViewInput>
            <p>Telefone*</p>
            <InputTel mask="(99) 99999-9999" maskChar="" noSpaceBetweenChars={true} value={phone_number} placeholder={"telefone"}
              onChange={(text) => { setPhone_number(text.target.value.replace(/[^0-9]/g, '')) }} />
          </ViewInput>
          <ViewInput>
            <p>Necessidade</p>
            <Input
              placeholder="necessidade"
              value={necessity}
              onChange={(event) => setNecessity(event.target.value)} />
          </ViewInput>
          <ViewInput>
            <p>Funcionários</p>
            <Input
              placeholder="funcionários"
              value={employees}
              onChange={(event) => setEmployees(event.target.value)} />
          </ViewInput>
          <ViewInput>
            <p>CNPJ</p>
            <Input
              placeholder="cnpj"
              value={cnpj}
              onChange={(event) => setCnpj(event.target.value)} />
          </ViewInput>
          <ViewInput>
            <p>Localização</p>
            <Input
              placeholder="localização"
              value={location}
              onChange={(event) => setLocation(event.target.value)} />
          </ViewInput>
          <ViewInput>
            <p>Observação</p>
            <TextArea
              style={{ minHeight: 60 }}
              placeholder="observação"
              value={observation}
              onChange={(event) => setObservation(event.target.value)} />
          </ViewInput>
          <footer className="content-footer">
            <span onClick={() => setIsOpen(false)}>Cancelar</span>
            <button style={{ background: "#f2760a", cursor: "pointer" }} onClick={async () => {
              //createLead()
            }}>
              {id ? "Editar" : "Criar"}
            </button>
          </footer>
        </div>
      </ModalConfirm>
      <ModalConfirm open={isOpenLead}>
        <div className="content" style={{ padding: 0 }}>
          <ContainerLead style={{ borderTopWidth: 30, margin: 0 }}>
            <MdClose
              style={{ position: "absolute", cursor: "pointer", top: -25, right: 10 }}
              size={20}
              color="#3a3a3a"
              onClick={() => setIsOpenLead(false)}
            />
            <header style={{ top: -20 }}>
              <Label color={"#f2760a"} />
              <p>Lead</p>

            </header>
            <p style={{ width: "calc(100% - 50px)" }}>{lead.name}</p>
            {
              lead.email && (
                <p style={{ fontSize: 12, color: "#0009" }}>Email: {lead.email}</p>
              )
            } 
            {
              lead.phone_number && (
                <p style={{ fontSize: 12, color: "#0009" }}>Telefone: {lead.phone_number}</p>
              )
            } 
            {
              lead.necessity && (
                <p style={{ fontSize: 12, color: "#0009" }}>Necessidade: {lead.necessity}</p>
              )
            } 
            {
              lead.employees && (
                <p style={{ fontSize: 12, color: "#0009" }}>Funcionarios: {lead.employees}</p>
              )
            } 
            {
              lead.cnpj && (
                <p style={{ fontSize: 12, color: "#0009" }}>CNPJ: {lead.cnpj}</p>
              )
            } 
            {
              lead.location && (
                <p style={{ fontSize: 12, color: "#0009" }}>Localização: {lead.location}</p>
              )
            } 
            {
              lead.observation && (
                <p style={{ fontSize: 12, color: "#0009", width: "85%" }}>Observação: {lead.observation}</p>
              )
            }
            <p style={{ marginBottom: 5 }}>{(lead.value || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            <div
              style={{ display: "flex", width: "100%", justifyContent: "space-between" }}
              onClick={() => {
              }}>

              <div
                style={{ display: "flex" }}>
                {
                  lead.phone_number && (
                    <FaWhatsapp onClick={() => {
                      window.open(`https://api.whatsapp.com/send/?phone=55${lead.phone_number}`)
                    }} size={18} color={"#0c0"} style={{ margin: "0 4px 0 0", cursor: "pointer" }} />
                  )}

                {
                  lead.phone_number && (
                    <MdPhone onClick={() => {
                      window.open(`tel:${lead.phone_number}`)
                    }} size={18} style={{ margin: "0 4px", cursor: "pointer" }} />
                  )}

                {
                  lead.email && (
                    <MdMail onClick={() => {
                      window.open(`mailto${lead.email}`)
                    }} size={20} color={"#FAB833"} style={{ margin: "0 4px", cursor: "pointer" }} />
                  )}
              </div>
            </div>
            {
              !!lead.leads?.length && (
                <p style={{ margin: "4px 0", fontSize: 13 }}>{lead.leads?.length} Franqueados</p>
              )
            }
            <div style={{maxHeight: 200, overflowY: "scroll"}}>
            {
              lead.leads?.map((item, index) => {
                return (
                  <div style={{borderBottom: index+1 != lead.leads?.length ? "1px solid #ccc" : "none", paddingBottom: 5, marginBottom: 5, marginRight: 10}}>
                    <p style={{ fontSize: 13, color: "#000", fontWeight: 400 }}>{item.user?.name}</p>
                    <p style={{ fontSize: 12, color: "#000", fontWeight: 700 }}>{item.status}</p>
                    <p style={{ fontSize: 10, color: "#555", fontWeight: 400 }}>{format(new Date(item.create_at), "dd/MM/yyyy HH:mm")}</p>
                  </div>
                )
              })
            }

            </div>
          </ContainerLead>
        </div>
      </ModalConfirm>
    </Container>
  );
};

export default LeadsFechados;
